import { jsx } from "react/jsx-runtime";
import { cloneElement, isValidElement } from "react";
import { useButton } from "@react-aria/button";
import { useMenuContext } from "./MenuContext";
import { Button } from "../../Button";
const isTriggerElement = (element) => {
  return typeof element !== "string" && isValidElement(element) && (element.type.displayName === "Button" || element.type === "button" || element.type === "a");
};
const isButtonElement = (element) => {
  return isValidElement(element) && element.type.displayName === "Button";
};
const Trigger = ({ label }) => {
  const { triggerRef, triggerProps } = useMenuContext();
  const labelProps = isTriggerElement(label) ? {
    ...triggerProps,
    ...label.props,
    // We have to manually convert some of the our own API for Button/label element to the
    // react-aria props. This ensures items like menu disable state work as intended.
    isDisabled: isButtonElement(label) ? label.props.isDisabled || label.props.isLoading : label.props.disabled ?? label.props.ariaDisabled
  } : triggerProps;
  const { buttonProps } = useButton(
    labelProps,
    triggerRef
  );
  return isTriggerElement(label) ? cloneElement(label, {
    ...buttonProps,
    ref: triggerRef
  }) : /* @__PURE__ */ jsx(
    Button,
    {
      ref: triggerRef,
      variant: "outline",
      ...buttonProps,
      children: label
    }
  );
};
export {
  Trigger
};
